import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'posts',
            name: 'post',
            class: 'Modules\\Post\\Entities\\Post'
        }
    },

    methods: {
        date(d) {
            const fecha = new Date(d.replace(' ', 'T'))

            const opciones = { day: 'numeric', month: 'long', year: 'numeric' }

            return fecha.toLocaleDateString('es-ES', opciones)
        }
    }
}